import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbtack, faSpinner, faPhoneVolume, faFileText } from "@fortawesome/free-solid-svg-icons";
import { formatNoteBody, FormatISODateTime } from '../helpers/formatting';
import { setModal } from "../redux/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import { hasUserPermission } from "../utils/permissionHelper";
import { selectUser } from "../redux/userSlice";

function NoteItem({ note, isPinned = false, handleClick, isLoading, canEditNote = false }) {
  const formattedNoteBody = formatNoteBody(note);
  const dispatch = useDispatch();
  const active = useSelector(selectUser)
  const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options

  const handleCallNote = (note) => {
    dispatch(
      setModal({
        is_active: true,
        type: 'call_note_modal',
        options: {
          note: note
        }
      })
    )
  }

  const handleTranscriptNote = (note) => {
    dispatch(
      setModal({
        is_active: true,
        type: 'transcript_note_modal',
        options: {
          note: note
        }
      })
    )
  }

  return (
    <div className={`has-background-grey-light ${isPinned ? "pinned-note" : ""} mt-1 mb-1`}>
      <div className="columns m-0 is-flex-direction-column">
        <div className="column pb-0 pt-2">
          <div className="columns my-0">
            <div className="column pb-0 pt-0 is-italic has-text-grey note-container">
              {note.created_by} - {FormatISODateTime(note.created_at)}
              {note.has_dialer_data && hasUserPermission(activePermissions, 'customer_note_dialer_data') && (
                <FontAwesomeIcon
                  icon={isLoading ? faSpinner : faPhoneVolume}
                  onClick={() => !isLoading && handleCallNote(note)}
                  className={`note-phone-icon is-size-4`}
                  spin={isLoading}
                  style={{ color: isLoading ? 'gray' : '' }}
                />
              )}
              {note.has_transcript_data && hasUserPermission(activePermissions, 'customer_note_transcript_data') && (
                <FontAwesomeIcon
                  icon={isLoading ? faSpinner : faFileText}
                  onClick={() => !isLoading && handleTranscriptNote(note)}
                  className={`note-phone-icon is-size-4`}
                  spin={isLoading}
                  style={{ color: isLoading ? 'gray' : '' }}
                />
              )}
              <FontAwesomeIcon
                icon={isLoading ? faSpinner : faThumbtack}
                onClick={() => !isLoading && handleClick(note)}
                className={`thumbtack-icon ${isPinned ? "pinned-thumbtack-icon" : ""} is-size-4`}
                spin={isLoading}
                style={{ color: isLoading ? 'gray' : '' }}
              />
            </div>
          </div>
          <div className="columns my-0">
            <div className="column py-0">
              <span className="has-text-weight-bold">Activity Code:</span>
            </div>
            <div className="column py-0">
              <span className="has-text-weight-light">
                {note?.activity_code_tag_label || 'N/A'}
              </span>
            </div>
          </div>
        </div>
        <div className="column py-0">
          <div className="columns my-0">
            <div className="column py-0">
              <span className="has-text-weight-bold">Disposition:</span>
            </div>
            <div className="column py-0">
              <span className="has-text-weight-light">
                {note?.result_code_tag_label || 'N/A'}
              </span>
            </div>
          </div>
        </div>
        <div className="column pt-0">
          <span className="tags pt-1 pb-0">
            {note?.tags?.map((tag) => (
              <span className="tag is-link is-rounded" style={{ marginBottom: "0.4rem", padding: "0.5em", height: "1.2em", }} key={tag?.id}>
                {tag?.label}
              </span>
            ))}
          </span>
        </div>
        <div className="column py-0 word-wrap-break-word">
          <span dangerouslySetInnerHTML={{ __html: formattedNoteBody }}></span>
        </div>
        {canEditNote ? (
          <div className="column py-0 has-text-right">
            <small><a href={`/customer_note/${note.id}`} className="note-detail-link">Note Detail</a></small>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default NoteItem;
